/* eslint-disable  react/prop-types */

import React from 'react';

const CalendarIcon = ({ width = 56, height = 56, style = {} }) => (
  <svg
    style={style}
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="5"
      y="11"
      width="46"
      height="36"
      rx="2"
      stroke="#00619E"
      strokeWidth="2"
    />
    <rect x="17" y="7" width="3" height="8" rx="1" fill="#00619E" />
    <rect x="36" y="7" width="3" height="8" rx="1" fill="#00619E" />
    <line x1="6" y1="21" x2="51" y2="21" stroke="#00619E" strokeWidth="2" />
    <mask id="path-5-inside-1" fill="white">
      <rect x="10" y="36" width="6" height="6" rx="1" />
    </mask>
    <rect
      x="10"
      y="36"
      width="6"
      height="6"
      rx="1"
      stroke="#00AED9"
      strokeWidth="4"
      mask="url(#path-5-inside-1)"
    />
    <mask id="path-6-inside-2" fill="white">
      <rect x="20" y="36" width="6" height="6" rx="1" />
    </mask>
    <rect
      x="20"
      y="36"
      width="6"
      height="6"
      rx="1"
      stroke="#00AED9"
      strokeWidth="4"
      mask="url(#path-6-inside-2)"
    />
    <mask id="path-7-inside-3" fill="white">
      <rect x="30" y="36" width="6" height="6" rx="1" />
    </mask>
    <rect
      x="30"
      y="36"
      width="6"
      height="6"
      rx="1"
      stroke="#00AED9"
      strokeWidth="4"
      mask="url(#path-7-inside-3)"
    />
    <mask id="path-8-inside-4" fill="white">
      <rect x="20" y="27" width="6" height="6" rx="1" />
    </mask>
    <rect
      x="20"
      y="27"
      width="6"
      height="6"
      rx="1"
      stroke="#00AED9"
      strokeWidth="4"
      mask="url(#path-8-inside-4)"
    />
    <mask id="path-9-inside-5" fill="white">
      <rect x="30" y="27" width="6" height="6" rx="1" />
    </mask>
    <rect
      x="30"
      y="27"
      width="6"
      height="6"
      rx="1"
      stroke="#00AED9"
      strokeWidth="4"
      mask="url(#path-9-inside-5)"
    />
    <mask id="path-10-inside-6" fill="white">
      <rect x="40" y="27" width="6" height="6" rx="1" />
    </mask>
    <rect
      x="40"
      y="27"
      width="6"
      height="6"
      rx="1"
      stroke="#00AED9"
      strokeWidth="4"
      mask="url(#path-10-inside-6)"
    />
  </svg>
);

export default CalendarIcon;
